import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiTooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

export type ITooltipProps = Omit<TooltipProps, 'color'> & {
    color?: 'primary' | 'white';
    withBoxWrapper?: boolean;
};

const StyledTooltip = styled(
    ({ className, children, ...props }: ITooltipProps) => (
        <MuiTooltip {...props} classes={{ popper: className }}>
            {children}
        </MuiTooltip>
    ),
    { shouldForwardProp: (propName) => propName !== 'color' }
)(
    ({ theme, color }) => `
        & .${tooltipClasses.arrow} {
            color: ${color === 'primary' ? theme.palette.primary.main : theme.palette.common.white};
        }

        & .${tooltipClasses.tooltip} {
            max-width: 20vw;
            padding: ${theme.spacing(1)};
            background-color: ${color === 'primary' ? theme.palette.primary.main : theme.palette.common.white};
            color: ${color === 'primary' ? theme.palette.common.white : theme.palette.text.primary};
            box-shadow: ${theme.shadows[8]};
            font-size: ${theme.typography.fontSize}px;
            font-weight: ${theme.typography.fontWeightMedium};
        }
    `
);

export const Tooltip = ({ children, withBoxWrapper = true, ...rest }: ITooltipProps) => (
    <StyledTooltip {...rest}>{withBoxWrapper ? <Box>{children}</Box> : children}</StyledTooltip>
);
